
const getObjectDetail = require('./getObjectDetail').default;

export const REQUEST_GET_ODRUDA_SSR = 'odrudaSsr/REQUEST_GET_ODRUDA_SSR';
export const RESPONSE_GET_ODRUDA_SSR = 'odrudaSsr/RESPONSE_GET_ODRUDA_SSR';

export const getOdrudaSsr = (id) => {
    return (dispatch, getState) => {
        getObjectDetail({
            id,
            objectName: 'odrudaSsr',
            requestFunc: requestGetOdrudaSsr,
            responseFunc: responseGetOdrudaSsr,
            url: '/api/odruda/ssr/',
            dispatch,
            getState
        });
    }
}

const requestGetOdrudaSsr = (id) => ({
    type: REQUEST_GET_ODRUDA_SSR,
    id
});

const responseGetOdrudaSsr = (res) => ({
    type: RESPONSE_GET_ODRUDA_SSR,
    error: res.error,
    data: res.data
});
